import { useEffect, useState } from "react";
import { Footprints, Users, Clock } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { EventCard } from "@/components/EventCard";
import { BookingDialog } from "@/components/BookingDialog";
import { api } from "@/lib/api";

const FAITS = [
  { icon: Clock, label: "Durée", valeur: "3 h 30 environ, à pied" },
  { icon: Users, label: "Groupe", valeur: "12 personnes au plus" },
  { icon: Footprints, label: "Niveau", valeur: "Marche facile, sans prérequis" },
];

export const RandonneeTerrain = () => {
  const [events, setEvents] = useState([]);
  const [soireesGourmandes, setSoireesGourmandes] = useState([]);
  const [booking, setBooking] = useState(null);
  useEffect(() => {
    api.events({ type: "randonnee" }).then(setEvents).catch(() => {});
    api.events({ type: "mystere_caquelon" }).then(setSoireesGourmandes).catch(() => {});
  }, []);
  if (events.length === 0 && soireesGourmandes.length === 0) return null;
  return <>
    {events.length > 0 && (
    <section id="randonnee" className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 lg:pt-24 pb-24 lg:pb-32 border-t border-sand-dark scroll-mt-28" data-testid="randonnee-terrain">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
        <Reveal className="lg:col-span-5">
          <p className="eyebrow mb-6">Sur le terrain — randonnée cosmo-tellurique</p>
          <h2 className="font-serif text-3xl sm:text-4xl text-bark leading-tight">Percevoir un lieu en marchant, <em className="not-italic text-terra">et comprendre ce qui s'y joue.</em></h2>
          <p className="text-fumee mt-5 leading-relaxed">
            Une après-midi de terrain en petit groupe : ressentir les variations d'un chemin, d'une clairière, d'une pierre ou d'un cours d'eau, et mettre des mots sur ce que la géobiologie appelle les phénomènes cosmo-telluriques — ce qui vient du ciel, ce qui monte de la terre, et la manière dont un lieu les tient ensemble.
          </p>
          <p className="text-fumee mt-4 leading-relaxed">
            Temps d'observation, exercices de perception simples et échanges. Accessible aux personnes qui découvrent la géobiologie comme à celles qui pratiquent déjà. Le lieu de rendez-vous est communiqué aux inscrits quelques jours avant.
          </p>
          <ul className="mt-8 divide-y divide-sand-dark border-y border-sand-dark" data-testid="randonnee-faits">
            {FAITS.map((f) => (
              <li key={f.label} className="py-3.5 flex items-center gap-4">
                <f.icon className="w-4 h-4 text-terra shrink-0" />
                <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-fumee w-20 shrink-0">{f.label}</span>
                <span className="text-sm text-bark">{f.valeur}</span>
              </li>
            ))}
          </ul>
        </Reveal>
        <div className="lg:col-span-7 grid md:grid-cols-2 gap-6">
          {events.map((e, i) => <EventCard key={e.id} event={e} index={i} onBook={setBooking} />)}
        </div>
      </div>
    </section>)}
    {soireesGourmandes.length > 0 && <section id="mystere-caquelon" className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 lg:pt-24 pb-24 lg:pb-32 border-t border-sand-dark scroll-mt-28" data-testid="mystere-caquelon-section">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
        <Reveal className="lg:col-span-5"><p className="eyebrow mb-6">Les soirées gourmandes d’Entre Les Mondes</p><h2 className="font-serif text-3xl sm:text-4xl text-bark leading-tight">Mystère & caquelon, <em className="not-italic text-terra">à la nuit tombée.</em></h2><p className="text-fumee mt-5 leading-relaxed">Une fondue au fromage à la Guinness, une forêt à la nuit tombée, quelques pierres millénaires et des histoires qui ne demandent qu’à être racontées.</p><p className="text-fumee mt-4 leading-relaxed">Une courte marche mène au lieu choisi ; le partage autour du caquelon reste au cœur de l’expérience.</p></Reveal>
        <div className="lg:col-span-7 grid md:grid-cols-2 gap-6">{soireesGourmandes.map((event, index) => <EventCard key={event.id} event={event} index={index} onBook={setBooking} />)}</div>
      </div>
    </section>}
    <BookingDialog event={booking} open={!!booking} onOpenChange={(v) => !v && setBooking(null)} />
  </>;
};
